import { HttpErrorResponse } from '@angular/common/http';
import { ApiProblem } from '../../api/models/api-problem';

/**
 * Turns anything a failed API call can throw into one line of text. The backend answers with an
 * RFC-7807 `ApiProblem`, whose `detail` carries the part worth reading — for the price import that
 * is the offending CSV line numbers, so it must survive verbatim.
 */
export function formatApiError(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    const problem = asRecord(error.error) as ApiProblem | undefined;
    const detail = [problem?.title, problem?.detail].filter(Boolean).join(' — ');
    if (error.status === 0) {
      return 'Die API ist nicht erreichbar. Bitte Verbindung prüfen und erneut versuchen.';
    }
    return detail ? `${error.status}: ${detail}` : `${error.status} ${error.statusText}`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return 'Unbekannter Fehler.';
  }
}

function asRecord(value: unknown): Record<string, unknown> | undefined {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : undefined;
}
